<goa-card alignItemsH="space-between" alignItemsV="center" cardSize="full">
  <goa-card-header>
    <h2>
      Associated materials ({{ tableData?.length }} total documents,
      {{ getTotalPages() }} total pages)
    </h2>
    <p *ngIf="associateMaterialsSupportText">
      {{ associateMaterialsSupportText }}
    </p>
  </goa-card-header>
  <goa-card-content>
    <div
      *ngIf="tableData?.length > 0"
      fxLayoutAlign="end"
      fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
    >
      <button
        mat-stroked-button
        color="primary"
        [disabled]="isDownloadButtonDisabled()"
        (click)="onDownloadFiles()"
      >
        <mat-icon>file_download</mat-icon>
        Download
      </button>
      <button
        *ngIf="canAssociateMaterial"
        mat-flat-button
        color="primary"
        (click)="onAssociateMaterials()"
      >
        Associate materials
      </button>
    </div>
    <form [formGroup]="form" autocomplete="off">
      <ng-container formArrayName="associatedMaterials">
        <table mat-table matSort [dataSource]="dataSource">
          <ng-container matColumnDef="select">
            <th class="w-5" mat-header-cell *matHeaderCellDef mat-sort-header>
              <mat-checkbox
                style="vertical-align: text-bottom"
                [checked]="allMaterialSelected"
                color="primary"
                [indeterminate]="someSelected()"
                (change)="selectAll($event.checked)"
              >
                Select all
              </mat-checkbox>
            </th>
            <td class="w-5" mat-cell *matCellDef="let e; let i = index">
              <div [formGroupName]="i">
                <mat-checkbox
                  class="md-field"
                  appearance="outline"
                  color="primary"
                  matInput
                  formControlName="selected"
                  (ngModelChange)="updateAllSelected()"
                  (click)="$event.preventDefault()"
                ></mat-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="fileName">
            <th class="w-11" mat-header-cell *matHeaderCellDef mat-sort-header>
              File name
            </th>
            <td class="w-20 mw-20" mat-cell *matCellDef="let e; let i = index">
              <div class="file-name">
                <a
                  (click)="$event.stopPropagation()"
                  [routerLink]=""
                  (click)="onOpenFile(e)"
                  >{{ e?.document?.name }}</a
                >
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th class="w-10" mat-header-cell *matHeaderCellDef mat-sort-header>
              Size
            </th>
            <td class="w-10" mat-cell *matCellDef="let e">
              {{ formatBytes(e?.document?.size) }} ({{ e?.document?.pages }}
              pages)
            </td>
          </ng-container>

          <ng-container matColumnDef="materialType">
            <th class="w-16" mat-header-cell *matHeaderCellDef mat-sort-header>
              Material type
            </th>
            <td class="w-12" mat-cell *matCellDef="let e">
              {{ e?.materialType }}
            </td>
          </ng-container>

          <ng-container matColumnDef="associatedBy">
            <th class="w-8" mat-header-cell *matHeaderCellDef mat-sort-header>
              Associated by
            </th>
            <td class="w-8" mat-cell *matCellDef="let e">
              {{ e?.associatedBy }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateFiled">
            <th class="w-8" mat-header-cell *matHeaderCellDef mat-sort-header>
              Date filed
            </th>
            <td class="w-8" mat-cell *matCellDef="let e">
              {{ e?.dateFiled | date: 'mediumDate' | incomplete }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let e; columns: displayedColumns; let i = index"
            (click)="onRowClick(i)"
          ></tr>
        </table>
      </ng-container>
    </form>
    <div
      *ngIf="tableData?.length <= 0"
      fxLayoutAlign="center center"
      fxLayout="column"
      class="mt-20"
    >
    <p *ngIf="associateMaterialsEmptyText">
      {{ associateMaterialsEmptyText }}
    </p>
      <!-- <p>
        No documents have been associated to this hearing yet. Click associate
        materials to add materials to this hearing.
      </p> -->
      <button
        *ngIf="canAssociateMaterial"
        mat-flat-button
        color="primary"
        (click)="onAssociateMaterials()"
      >
        Associate materials
      </button>
    </div>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      [pageSize]="10"
      showFirstLastButtons
    ></mat-paginator>
  </goa-card-content>
</goa-card>
